module.exports = __webpack_public_path__ + "static/media/R-300HD_CrossSection.03e9348c.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/es/R-300HD_CrossSection.png
// module id = 487
// module chunks = 0